const {Backbone} = require('backboneAdapter');
import GenericModel from 'js/models/generic.model';

    export default GenericModel.extend({
        urlRoot : '/CampaignCloud/CustomFields',
        idAttribute : 'id',
        defaults : {
            type : null,
            name : null
        }
    });
